<!--  Modal Header -->
<div class="modal-header">
    <h3 class="modal-title">{{modalTitle}}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <div class="panel-body" [hidden]="minimise">
  <div>
    <!-- SMALL loader for form content only -->
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    @if (!showFormLoader) {
<div>
      <!-- Row 1: Schedule + Basket -->
      <div class="form-row mb-20" style="display: flex; gap: 20px;">
        <!-- Schedule dropdown - ENABLED in ADD mode, DISABLED in EDIT mode -->
        <div class="form-group" style="flex: 1 1 calc(50% - 10px); max-width: calc(50% - 10px);">
          <label for="schedule" class="control-label">Schedule</label>
          <select id="FTC_OVRDS_UD_2"
                  class="form-control"
                  [(ngModel)]="schedule"
                  [compareWith]="compareByCodeKey"
                  [disabled]="isEditMode"
                  (change)="scheduleChange()">
            @for (option of scheduleData; track $index) {
<option [ngValue]="option">
              {{option.LINE_DESCRIPTION}}
            </option>
}
          </select>
        </div>

        <!-- Basket dropdown - Conditional disabled: EDIT mode OR (!schedule || isSchdJ || isBasketGENLIM) in ADD mode -->
        <div class="form-group" style="flex: 1 1 calc(50% - 10px); max-width: calc(50% - 10px);">
          <label for="basket" class="control-label">Basket</label>
          <select id="FTC_OVRDS_UD_3"
                  class="form-control"
                  [(ngModel)]="basket"
                  [compareWith]="compareByBasketKey"
                  [disabled]="isEditMode || !schedule || isSchdJ || isBasketGENLIM"
                  (change)="getScheduleLineColAmountAndReason()">
            @for (option of basketData; track $index) {
<option [ngValue]="option">
              {{option.BASKET_DESC}}
            </option>
}
          </select>
        </div>
      </div>

      <!-- Row 2: Line + Column -->
      <div class="form-row mb-20" style="display: flex; gap: 20px;">
        <!-- Line dropdown - ENABLED in ADD mode (if schedule selected), DISABLED in EDIT mode -->
        <div class="form-group" style="flex: 1 1 calc(50% - 10px); max-width: calc(50% - 10px);">
          <label for="lineNo" class="control-label">Line</label>
          <select id="FTC_OVRDS_UD_4"
                  class="form-control"
                  [(ngModel)]="lineNo"
                  [compareWith]="compareByCodeKey"
                  [disabled]="isEditMode || !schedule"
                  (change)="lineNoChange()">
            @if (isAddMode && !lineNo) {
<option [ngValue]="null"></option>
}
            @for (option of lineData; track $index) {
<option [ngValue]="option">
              {{option.LINE_DESCRIPTION}}
            </option>
}
          </select>
        </div>

        <!-- Column dropdown - ENABLED in ADD mode (if lineNo.LINE_DESCRIPTION exists), DISABLED in EDIT mode -->
        <div class="form-group" style="flex: 1 1 calc(50% - 10px); max-width: calc(50% - 10px);">
          <label for="colNo" class="control-label">Column</label>
          <select id="FTC_OVRDS_UD_5"
                  class="form-control"
                  [(ngModel)]="colNo"
                  [compareWith]="compareByCodeKey"
                  [disabled]="isEditMode || !lineNo || !lineNo?.LINE_DESCRIPTION">
            @if (isAddMode && !colNo) {
<option [ngValue]="null"></option>
}
            @for (option of colData; track $index) {
<option [ngValue]="option">
              {{option.LINE_DESCRIPTION}}
            </option>
}
          </select>
        </div>
      </div>

      <!-- Row 3: Amount + Reason -->
      <div class="form-row mb-20" style="display: flex; gap: 20px;">
        <!-- Amount input - 50% width -->
        <div class="form-group" style="flex: 1 1 calc(50% - 10px); max-width: calc(50% - 10px);">
          <label for="amount" class="control-label">Amount</label>
          <input type="text"
                 id="FTC_OVRDS_UD_6"
                 class="form-control"
                 [(ngModel)]="amount"
                 (keydown)="onAmountKeydown($event)"
                 pattern="^-?[0-9]*\.?[0-9]{0,2}$" />
        </div>

        <!-- Reason textarea - 50% width -->
        <div class="form-group" style="flex: 1 1 calc(50% - 10px); max-width: calc(50% - 10px);">
          <label for="reason" class="control-label">Reason</label>
          <textarea id="FTC_OVRDS_UD_7"
                    class="form-control"
                    [(ngModel)]="reason"
                    rows="3"></textarea>
        </div>
      </div>

      <!-- Row 4: SIC Code (disabled when not HPI schedule)-->
      <div class="form-row mb-20" style="display: flex; gap: 20px;">
        <div class="form-group sic-code-field" style="flex: 1 1 calc(50% - 10px); max-width: calc(50% - 10px);">
          <label for="sicCode" class="control-label">SIC Code</label>
          <select id="FTC_OVRDS_UD_2a"
                  class="form-control"
                  [(ngModel)]="selectedSICCode"
                  [compareWith]="compareByCodeKey"
                  [disabled]="!isSchdHPI">
            @if (!selectedSICCode) {
<option [ngValue]="null"></option>
}
            @for (item of sicCodeList; track $index) {
<option [ngValue]="item">
              {{item.CODE_SHORT_DESC}} - {{item.CODE_DESCRIPTION}}
            </option>
}
          </select>
        </div>
      </div>
    </div>
}
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
  <!-- Delete button only visible in EDIT mode -->
  @if (isEditMode) {
<button
          class="delete-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="deleteAmt()">Delete</button>
}
</div>

<!-- DELETE CONFIRMATION OVERLAY -->
@if (showModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="modalConfig"
    [visible]="false"
    (confirmed)="onConfirm()"
    (cancelled)="onCancel()"
    (closed)="onCancel()">
  </gtw-confirmation-modal>
</div>
}

